import { AppBar, Box, Paper, Stack, Toolbar } from '@mui/material'
import { grey } from '@mui/material/colors'
import React, { useCallback, useEffect, useState } from 'react'
import TechInfo from '../../components/TechInfo'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux';
import EllipsisTypography from '../../components/EllipsisTypography'
import { getSystemAnnouncementInfo } from './utils'
import CardInfoWrapper from './CardInfoWrapper'
import EditSystemAnnouncementDialog from './EditSystemAnnouncementDialog'
import { getSystemAnnouncementDetails, updateSystemAnnouncementByKey } from '../../apis/systemAnnouncementApis'
import Loader from '../ContractDetails/Components/Loader'
import { toastActions } from '../../_actions'


const SystemAnnouncement = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [editSystemAnnouncementsDialog, setEditSystemAnnouncementsDialog] = useState({ open: false, tabId: "" })
  const [systemAnnouncementData, setSystemAnnouncementData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchSystemAnnouncementDetails = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getSystemAnnouncementDetails();
      setSystemAnnouncementData(res.data);
    } finally {
      setLoading(false);
    }
  }, []);


  useEffect(() => {
    fetchSystemAnnouncementDetails();
  }, [fetchSystemAnnouncementDetails]);

  const handleEditSystemAnnouncementModal = (value) => {
    setEditSystemAnnouncementsDialog({ open: value ? true : false, tabId: value })
  }


  const updateSystemAnnouncementDetails = async (data) => {
    try {
      setLoading(true);
      await updateSystemAnnouncementByKey(data);
      dispatch(toastActions.success(t("systemAnnouncement.detailsUpdated")))
      fetchSystemAnnouncementDetails();
      setEditSystemAnnouncementsDialog({ open: false, tabId: '' })
    } catch (error) {
      dispatch(toastActions.error(t("general.failedToUpdate")))
    } finally {
      setLoading(false);
      setEditSystemAnnouncementsDialog({ open: false, tabId: '' })
    }
  };

  return (
    <Box height={'100%'} >
      {loading ? (
        <Loader />
      ) : (
        <>
          <AppBar position="sticky" color="inherit"  >
            <Toolbar variant="dense" >
              <Stack direction="row" sx={{
                alignItems: "center"
              }}>
                <EllipsisTypography variant={"h6"} title={t('systemAnnouncement.title')} />
              </Stack>
            </Toolbar>
          </AppBar>
          <Box
            sx={{
              flexGrow: 1,
              bgcolor: grey[100],
              p: 2,
              overflow: "auto",
              height: '100%'
            }}>
            <Stack sx={{
              flexGrow: 1,
              my: 2,
            }} spacing={2}>

              <Paper sx={{ width: "100%", bgcolor: "common.white" }} elevation={0}>
                <CardInfoWrapper title={t('taskAutomation.generalSettings')}
                  details={getSystemAnnouncementInfo(systemAnnouncementData, t)}
                  loading={loading}
                  onEdit={handleEditSystemAnnouncementModal}
                  onSuccess={fetchSystemAnnouncementDetails}
                  systemAnnouncementData={systemAnnouncementData}
                  updateSystemAnnouncementDetails={updateSystemAnnouncementDetails}
                />
              </Paper>
              <Paper sx={{ width: '100%', bgcolor: 'common.white' }} elevation={0} >
                <TechInfo title={t('general.techInfo')} subtitle={t("general.mutationHistory")} data={systemAnnouncementData} />
              </Paper>
            </Stack>
          </Box>
          {editSystemAnnouncementsDialog.open && (
            <EditSystemAnnouncementDialog
              isOpenEditIconDialog={editSystemAnnouncementsDialog}
              systemAnnouncementData={systemAnnouncementData}
              onClose={() =>
                setEditSystemAnnouncementsDialog({ open: false, tabId: '' })
              }
              updateSystemAnnouncementDetails={updateSystemAnnouncementDetails}

            />
          )}
        </>
      )}
    </Box>
  )
}

export default SystemAnnouncement
